<script setup>
import { useVModel } from '@vueuse/core';
import { IconTrash } from '@tabler/icons-vue';
import FormLabel from '@/components/Forms/FormLabel.vue';
import FormInput from '@/components/Forms/FormInput.vue';
import AppCard from '@/Shared/AppCard.vue';
import AppWell from '@/Shared/AppWell.vue';
import PlusButton from '@/components/Forms/PlusButton.vue';
import FormError from '@/components/Forms/FormError.vue';

let emit = defineEmits(['update:modelValue']);
const props = defineProps({
    modelValue: {
        required: true,
    },
    errors: {
        required: true,
    },
});

const maxItems = 10;

const links = useVModel(props, 'modelValue', emit);
const addLink = () => {
    if (props.modelValue.length < maxItems) {
        links.value.push({
            title: '',
            url: '',
        });
    }
};
const deleteLink = (index) => {
    links.value.splice(index, 1);
};
</script>

<template>
    <div>
        <div>
            <div>{{ $tc('messages.links', 2) }}</div>
            <div>
                <FormError :value="errors.links" class="mt-2" />
            </div>
        </div>
        <AppWell>
            <div class="px-2 py-4" v-auto-animate>
                <AppCard v-for="(link, index) in links" :key="index" class="mt-3">
                    <div class="p-2">
                        <div>
                            <FormLabel :value="$t('messages.title')" for="title" />
                            <FormInput
                                required
                                id="title"
                                v-model="link.title"
                                type="text"
                                name="title"
                                class="mt-1 w-full"
                            />

                            <FormError :value="errors[`links.${index}.title`]" class="mt-2" />
                        </div>
                        <div>
                            <FormLabel :value="$t('messages.url')" for="url" />
                            <FormInput
                                required
                                id="url"
                                v-model="link.url"
                                type="text"
                                name="url"
                                class="mt-1 w-full"
                            />
                            <FormError :value="errors[`links.${index}.url`]" class="mt-2" />
                        </div>
                        <button type="button" :title="$t('messages.remove')" @click="deleteLink(index)">
                            <IconTrash class="text-gray-400 pr-1" />
                        </button>
                    </div>
                </AppCard>
            </div>

            <div class="mt-3" v-if="links.length < maxItems">
                <PlusButton @click="addLink()" />
            </div>
        </AppWell>
    </div>
</template>
